<template>
	<div ref="el" data-component="product-card" :data-shader="even ? 'gold-card-even' : 'gold-card-odd'" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
		<svg width="0" height="0" viewBox="0 0 493 493" style="position: absolute">
			<defs>
				<clipPath id="product-card-clip-1" clipPathUnits="objectBoundingBox" transform="scale(0.00203 0.00203)">
					<path
						d="M196.217 0C189.731 0 183.509 2.57685 178.923 7.16368L7.16368 178.923C2.57686 183.509 0 189.731 0 196.217V468.377C0 481.885 10.9504 492.835 24.4583 492.835H296.618C303.105 492.835 309.326 490.259 313.913 485.672L485.672 313.913C490.259 309.326 492.835 303.105 492.835 296.618V24.4583C492.835 10.9504 481.885 0 468.377 0H196.217Z"
					/>
				</clipPath>
				<clipPath id="product-card-clip-2" clipPathUnits="objectBoundingBox" transform="scale(0.00203 0.00203)">
					<path
						d="M296.618 0C303.105 0 309.326 2.57685 313.913 7.16368L485.672 178.923C490.259 183.509 492.835 189.731 492.835 196.217V468.377C492.835 481.885 481.885 492.835 468.377 492.835H196.217C189.731 492.835 183.51 490.259 178.923 485.672L7.16373 313.913C2.57687 309.326 3.05176e-05 303.105 3.05176e-05 296.618V24.4583C3.05176e-05 10.9504 10.9504 0 24.4584 0H296.618Z"
					/>
				</clipPath>
			</defs>
		</svg>

		<div class="corner-overlay top-left"></div>
		<div class="corner-overlay top-right"></div>
		<div class="corner-overlay bottom-left"></div>
		<div class="corner-overlay bottom-right"></div>

		<div class="external">
			<span ref="extTitleRef" class="external-title -title-1 -uppercase">{{ title }}</span>
			<span :class="`description ${even ? '' : 'odd'}`">{{ description }}</span>
		</div>

		<div ref="shapeRef" class="content">
			<div :class="`title-container ${even ? '' : 'odd'}`">
				<h1 class="title -title-3 -uppercase">{{ title }}</h1>
				<div v-if="comingSoon" class="coming-soon -text-1">
					<span>coming soon</span>
				</div>
			</div>
			<h2 :class="`subtitle ${even ? '' : 'odd'} -title-3`">{{ subtitle }}</h2>
			<div class="shape" :class="even ? 'shape-1' : 'shape-2'">
				<div class="blur-layer"></div>
				<svg v-if="even" viewBox="0 0 493 493" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g data-figma-bg-blur-radius="54">
						<path
							d="M196.217 0C189.731 0 183.509 2.57685 178.923 7.16368L7.16368 178.923C2.57686 183.509 0 189.731 0 196.217V468.377C0 481.885 10.9504 492.835 24.4583 492.835H296.618C303.105 492.835 309.326 490.259 313.913 485.672L485.672 313.913C490.259 309.326 492.835 303.105 492.835 296.618V24.4583C492.835 10.9504 481.885 0 468.377 0H196.217Z"
							fill="#FFA600"
							fill-opacity="0.3"
						/>
						<path
							d="M196.217 0C189.731 0 183.509 2.57685 178.923 7.16368L7.16368 178.923C2.57686 183.509 0 189.731 0 196.217V468.377C0 481.885 10.9504 492.835 24.4583 492.835H296.618C303.105 492.835 309.326 490.259 313.913 485.672L485.672 313.913C490.259 309.326 492.835 303.105 492.835 296.618V24.4583C492.835 10.9504 481.885 0 468.377 0H196.217Z"
							fill="#FFA600"
							fill-opacity="0.05"
						/>
					</g>
				</svg>
				<svg v-else viewBox="0 0 493 493" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g data-figma-bg-blur-radius="54">
						<path
							d="M296.618 0C303.105 0 309.326 2.57685 313.913 7.16368L485.672 178.923C490.259 183.509 492.835 189.731 492.835 196.217V468.377C492.835 481.885 481.885 492.835 468.377 492.835H196.217C189.731 492.835 183.51 490.259 178.923 485.672L7.16373 313.913C2.57687 309.326 3.05176e-05 303.105 3.05176e-05 296.618V24.4583C3.05176e-05 10.9504 10.9504 0 24.4584 0H296.618Z"
							fill="#FFA600"
							fill-opacity="0.3"
						/>
						<path
							d="M296.618 0C303.105 0 309.326 2.57685 313.913 7.16368L485.672 178.923C490.259 183.509 492.835 189.731 492.835 196.217V468.377C492.835 481.885 481.885 492.835 468.377 492.835H196.217C189.731 492.835 183.51 490.259 178.923 485.672L7.16373 313.913C2.57687 309.326 3.05176e-05 303.105 3.05176e-05 296.618V24.4583C3.05176e-05 10.9504 10.9504 0 24.4584 0H296.618Z"
							fill="#FFA600"
							fill-opacity="0.05"
						/>
					</g>
				</svg>
			</div>
		</div>
	</div>
</template>

<script setup>
import { gsap, ScrollTrigger } from 'gsap/all'
import { useScreen } from 'vue-screen'
import { useEmitter } from '~/composables/core'
import { breakpoints } from '~/config'

import.meta.client && gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
	title: { type: String, default: undefined },
	subtitle: { type: String, default: undefined },
	description: { type: String, default: undefined },
	comingSoon: { type: Boolean, default: false },
	even: { type: Boolean, default: false },
})

const el = ref(null)
const shapeRef = ref(null)
const extTitleRef = ref(null)
const context = inject('pageContext')
const screen = useScreen()
const emitter = useEmitter()

let scrollTrigger = null

watch(
	() => screen?.width,
	async () => {
		kill()
		await nextTick()
		setup()
	}
)

const handleMouseEnter = () => {
	if (screen.touch) return

	gsap.killTweensOf(shapeRef.value)
	gsap.killTweensOf(extTitleRef.value)

	gsap.to(shapeRef.value, {
		duration: 1.0,
		scale: 1.02,
		ease: 'expo.out',
	})
	gsap.to(extTitleRef.value, {
		duration: 1.0,
		//filter: 'blur(12px)',
		delay: 0.05,
		scale: 1.02,
		ease: 'power4.out',
	})

	emitter.emit('shaderCanvas-mouseEnter', el.value.dataset.shader)
}
const handleMouseLeave = () => {
	if (screen.touch) return

	gsap.killTweensOf(shapeRef.value)
	gsap.killTweensOf(extTitleRef.value)

	gsap.to(shapeRef.value, {
		duration: 0.5,
		scale: 1.0,
		ease: 'power2.out',
	})
	gsap.to(extTitleRef.value, {
		duration: 1.0,
		//filter: 'blur(0px)',
		delay: 0.1,
		scale: 1.0,
		ease: 'power4.out',
	})

	emitter.emit('shaderCanvas-mouseLeave', el.value.dataset.shader)
}

const setup = () => {
	if (!el.value) return

	const externalTitle = el.value.querySelector('.external-title')
	if (!externalTitle) return

	scrollTrigger = ScrollTrigger.create({
		trigger: el.value,
		start: 'top bottom',
		end: 'bottom top',
		scrub: 0.5,
		onUpdate: (self) => {
			const progress = self.progress
			const yOffset = screen.width < breakpoints.xsmall ? -progress * 35 : -progress * 20 + 5

			gsap.to(externalTitle, { yPercent: yOffset, duration: 2.0, ease: 'power2.out' })
		},
	})
}
const init = () => {}
const kill = () => {
	scrollTrigger?.kill()
}

onBeforeUnmount(() => {
	kill()
})

onMounted(() => {
	context.$page.loader.ready.then(() => setup())
})
</script>

<style lang="scss" scoped>
[data-component='product-card'] {
	--page-background-color: var(--color-geral-brown);

	position: relative;

	//background-color: red;

	width: 100%;
	//height: rs(750, 750);

	padding: rs(120, 120) 0;

	justify-content: center;
	align-items: center;
	display: flex;

	.corner-overlay {
		position: absolute;
		width: rs(14);
		height: rs(14);
		pointer-events: none;
	}

	.corner-overlay.top-left {
		top: 0;
		left: 0;
		margin-top: -2px;
		margin-left: -2px;
		background: radial-gradient(circle at 100% 100%, transparent rs(12), var(--page-background-color, #ffffff) rs(12));
	}

	.corner-overlay.top-right {
		top: 0;
		right: 0;
		margin-top: -2px;
		margin-right: -2px;
		background: radial-gradient(circle at 0% 100%, transparent rs(12), var(--page-background-color, #ffffff) rs(12));
	}

	.corner-overlay.bottom-left {
		bottom: 0;
		left: 0;
		margin-bottom: -2px;
		margin-left: -2px;
		background: radial-gradient(circle at 100% 0%, transparent rs(12), var(--page-background-color, #ffffff) rs(12));
	}

	.corner-overlay.bottom-right {
		bottom: 0;
		right: 0;
		margin-bottom: -2px;
		margin-right: -2px;
		background: radial-gradient(circle at 0% 0%, transparent rs(12), var(--page-background-color, #ffffff) rs(12));
	}

	.external {
		position: absolute;

		width: 100%;
		height: 100%;

		overflow: hidden;
	}

	.external-title {
		position: absolute;
		bottom: -40px;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;

		font-size: rs(300, 150);
		font-weight: 600;
		z-index: -1;
	}

	.description {
		position: absolute;

		top: rs(32, 32);
		left: rs(32, 32);

		width: 30%;

		opacity: 0.5;
		white-space: pre-line;

		@include max-width($lg) {
			width: auto;
			right: rs(32, 32);
		}

		@include max-width($xxs) {
			left: rs(16, 16);
			right: rs(16, 16);
			top: rs(16, 16);
		}

		&.odd {
			left: auto;
			right: rs(32, 32);

			@include max-width($lg) {
				width: auto;
				left: rs(32, 32);
			}

			@include max-width($xxs) {
				left: rs(16, 16);
				right: rs(16, 16);
				top: rs(16, 16);
			}
		}
	}

	.content {
		position: relative;
		width: 75%;

		.title-container {
			position: absolute;
			top: rs(20, 20);
			right: rs(30, 30);

			z-index: 1;

			display: flex;
			flex-direction: row;
			gap: rs(12, 12);

			@include max-width($xxs) {
				top: rs(36, 36);
				right: rs(16, 16);

				flex-direction: column;
				gap: rs(2, 2);
			}

			&.odd {
				left: rs(30, 30);
				right: auto;

				@include max-width($xxs) {
					left: rs(16, 16);
				}
			}

			.coming-soon {
				opacity: 0.5;

				font-size: rs(12, 12);

				align-items: center;
				display: flex;

				//padding-top: rs(8, 4);

				span {
					border: 1px solid var(--color-geral-creme);
					border-radius: rs(12, 12);
					padding: rs(4, 4) rs(10, 10);
				}
			}
		}

		.subtitle {
			position: absolute;
			bottom: rs(30, 30);
			left: rs(30, 30);
			width: rs(300);

			z-index: 1;

			@include max-width($xxs) {
				bottom: rs(16, 16);
				left: rs(16, 16);
			}

			&.odd {
				right: rs(25, 25);
				left: auto;

				@include max-width($xxs) {
					right: rs(16, 16);
				}
			}
		}

		.shape {
			position: relative;
			width: 100%;
			aspect-ratio: 1 / 1;

			@include max-width($xxs) {
				margin-top: rs(24, 24);
			}

			.blur-layer {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				backdrop-filter: blur(27px);
				-webkit-backdrop-filter: blur(27px);
			}

			:deep(svg) {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: block;

				foreignObject {
					display: none;
				}
			}

			&.shape-1 .blur-layer {
				clip-path: url(#product-card-clip-1);
			}

			&.shape-2 .blur-layer {
				clip-path: url(#product-card-clip-2);
			}
		}
	}
}
</style>
